/**
 * Authentication Service Exports
 * 
 * This file creates and exports the configured authentication service instance.
 * It uses Supabase as the provider but can be easily switched to another provider
 * by changing the implementation classes.
 */

import { supabase } from '../supabase/client';
import { TenantAuthService } from './AuthService';
import { SupabaseAuthProvider } from './providers/SupabaseAuthProvider';
import { SupabaseTenantQueries } from './providers/SupabaseTenantQueries';

// Export types
export * from './interfaces';

// Create provider instances
const authProvider = new SupabaseAuthProvider(supabase);
const tenantQueries = new SupabaseTenantQueries(supabase);

// Create and export the main auth service instance
export const authService = new TenantAuthService(authProvider, tenantQueries);

// Export the class for testing purposes
export { TenantAuthService };

